import type { Theme } from '@mui/material';
import { toggleButtonClasses } from '@mui/material';
import type { Components } from '@mui/material/styles';

import { colorList } from '@/mui/constants/palette';

type Variant = {
  props: Record<string, unknown>;
  style: Record<string, unknown>;
};

export default function MUIToggleButtonGroup(theme: Theme): Components['MuiToggleButtonGroup'] {
  return {
    defaultProps: {
      color: 'primary',
    },

    variants: [
      ...colorList.reduce<Variant[]>(
        (acc, key) =>
          acc.concat({
            props: {
              color: key,
            },
            style: {
              [`& .${toggleButtonClasses.root}`]: {
                [`&.${toggleButtonClasses.selected}`]: {
                  color: theme.palette[key].contrastText,
                  backgroundColor: theme.palette[key].main,

                  '&:hover': {
                    backgroundColor: theme.palette[key].dark,
                  },
                },
              },
            },
          }),
        [],
      ),
      {
        props: {
          color: 'neutral',
        },
        style: {
          [`& .${toggleButtonClasses.root}`]: {
            [`&.${toggleButtonClasses.selected}`]: {
              color: theme.palette.shades[900],
              backgroundColor: theme.palette.shades[300],

              '&:hover': {
                backgroundColor: theme.palette.shades[400],
              },
            },
          },
        },
      },
    ],
  };
}
